<template>
    <div class="">
        <a href="#!" @click="$emit('editpost')"
            v-if="isDev">Edit</a>
        <!-- <button class="btn" @click="copyToClipboard(`${this.location.origin}/notes?jsonurl=${btoa('http://automation:9000/get/crashcode2/c53dc12f2f9049bbb3248fc768710240')}`)">Copy embed</button> -->
        <h3 style="margin:0;padding;0;">{{ title }}</h3>
        <!-- <div style="min-width:300px;max-width:300px;float:left;"> -->
        <div class="leftside">
            <NotesListL2
                :notelist="tree"
                :edit="false"
                @newfile="newFileHandler"
            />
        </div>
        <!-- <div style="width:69%;float:left;"> -->
        <div class="rightside">
            <!-- <NoteEditL2 v-if="edit"
                :key="forceRefreshEdit"
                @saveFile="saveFileHandler"
                :treeObj="treeObj"/> -->
            <h4>{{this.treeObj.title}}</h4>
            <MKRender 
                v-if="treeSelected"
                :key="this.treeObj.title"
                :source="treeObj.content"/>
        </div>
    </div>
</template>

<style>
.leftside{
    float:left;
    width:300px;
}
.rightside{
    float:left;
    width: calc(100% - 300px)
}
@media only screen 
    and (min-device-width: 320px) 
    and (max-device-width: 568px)
    and (orientation: portrait) {
        .rightside{
            width: 100%;
        }
}
</style>

<script>
import MKRender from '../MKRender/main'
import NotesListL2 from '../NotesListL2/main'
import NoteEditL2 from '../NoteEditL2/main'

export default {
    name: '',
    props: ['noteSelected'],
    components: {
        MKRender,
        NotesListL2,
        NoteEditL2,
    },
    data(){
        return {
            forceRefreshEdit: 0,
            title: '',
            tree: [], // path, content
            treeSelected: null,
            treeObj: {
                title: '',
                content: '',
            },
        }
    },
    beforeMount(){
        this.title = this.noteSelected.title
        if (window.location.href.startsWith('https://') || this.noteSelected.cached){
            console.log('noteselected cached', this.noteSelected.cached)
            this.title = this.noteSelected.title
            this.tree = this.noteSelected.tree
            if (this.$route.query.subtitle){
                setTimeout(() => {
                    this.newFileHandler(this.$route.query.subtitle)
                })
            }
        }else{
            if (this.noteSelected.key){
                this.axios.get(this.$apiprefix+'/get/'+this.$col+'/'+this.noteSelected.key).then(rs => {
                    console.log(rs.data)
                    this.title = rs.data.title
                    this.tree = rs.data.tree || []
                    this.tree = this.tree.sort((a,b) => a.title < b.title ? -1 : 1)
                    if (this.$route.query.subtitle){
                        setTimeout(() => {
                            this.newFileHandler(this.$route.query.subtitle)
                        })
                    }
                })
            }
        }
        window.newFile = this.newFileHandler
        window.fileClick = this.newFileHandler
    },
    mounted(){
    },
    methods: {
        newFileHandler(title=''){
            console.log('new file handler', title)
            if (title != ''){
                // console.log(process.env)
                let jsonurl = ''
                if (this.$route.query.jsonurl){
                    jsonurl = '&jsonurl='+this.$route.query.jsonurl
                }
                window.history.pushState({}, null, process.env.BASE_URL+`?title=${this.title}&subtitle=${title}${jsonurl}`)
                let treeObj = this.tree.filter(d => d.title == title)
                if (treeObj.length > 0){
                    treeObj = treeObj[0]
                    console.log('treeobj', treeObj)
                    this.treeSelected = title
                    this.treeObj = treeObj
                    this.edit = true
                    this.forceRefreshEdit++
                    return
                }
            }
            let treeObj = {
                title: title,
                content: '',
            }
            // this.tree.push(treeObj)
            this.forceRefreshEdit++
            this.treeSelected = title
            this.treeObj = treeObj
            this.edit = true
        },
    },
}
</script>

<style>

</style>